<template>
    <div id="app">
        <flow-menu></flow-menu>
        <div id="flow-content">
            <a id="scroll-to-top" href="#" v-if="scrolled" class="w3-animate-opacity-slow w3-left zero-bottom">
                <i class="fa fa-3x fa-chevron-circle-up w3-text-deep-orange flow-padding-left flow-padding-right w3-round-large text-shadow" title="Go to top"></i>
            </a>
            <router-view/>
        </div>
        <flow-footer v-if="!scrolled" class="w3-animate-opacity-slow"></flow-footer>

    </div>
</template>

<script>
    import Footer from '@/components/common/Footer'
    import SideMenu from '@/components/common/SideMenu'
    import ContentHeader from '@/components/common/ContentHeader'

    export default {
        name: 'Layout',
        components: {
            'flow-footer': Footer,
            'flow-menu': SideMenu,
            'content-header': ContentHeader
        },
        data() {
            return{
                scrolled: false
            }
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);
            this.handleScroll();
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            handleScroll() {
                this.scrolled = window.pageYOffset > 200;
            }
        }
    }
</script>

<style>

</style>